import React from "react";
import "./dashboard.css";
import Spinner from "../../commanComponents/Spinner";

export default function Cards({ img, cardText, value, graphImg, loading }) {
  return (
    <div className="card p-3">
      <div className="d-flex align-items-center flex-wrap">
        <div className="me-2 mb-2">{img}</div>
        <h6 className="m-0">{cardText}</h6>
      </div>

      <div className="d-flex align-items-center mt-3 flex-wrap">
        <h6
          style={{
            fontSize: "26px",
            fontWeight: "500",
            margin: "0px",
            minWidth: "100px",
          }}
        >
          {loading ? <Spinner /> : value}
        </h6>
        <p className="m-0 ms-2">{cardText}</p>
      </div>

      <div className="mt-4">{graphImg}</div>
    </div>
  );
}
